export const tosConstants = {
  GET_TOS_SUCCESS: "GET_TOS_SUCCESS",
  SHOW_TOS_SUCCESS: "SHOW_TOS_SUCCESS",
  UPDATE_TOS_SUCCESS: "UPDATE_TOS_SUCCESS",
  ADD_TOS_SUCCESS: "ADD_TOS_SUCCESS",
  STORE_TOS_SUCCESS: "STORE_TOS_SUCCESS",
  REMOVE_TOS_SUCCESS: "REMOVE_TOS_SUCCESS",
  REMOVE_TOS_REQUEST: "REMOVE_TOS_REQUEST",
  REMOVE_TOS_FAILURE: "REMOVE_TOS_FAILURE",
  ADD_TOS_SECTION_SUCCCESS: "ADD_TOS_SECTION_SUCCCESS",
  GET_TOS_SECTION_SUCCESS: "GET_TOS_SECTION_SUCCESS",
};
